import { toast } from "react-toastify";

/** Stable admin-shell container (AdminLayout) — billing toasts target this. */
export const ADMIN_TOAST_CONTAINER_ID = "admin";

export const showToast = (type, message, customOptions = {}) => {
    const defaultOptions = {
        position: "top-center",
        theme: "colored",
        hideProgressBar: true,
    };

    const options = { ...defaultOptions, ...customOptions };

    switch (type) {
        case "success":
            toast.success(message, options);
            break;
        case "error":
            toast.error(message, options);
            break;
        case "info":
            toast.info(message, options);
            break;
        case "warning":
            toast.warning(message, options);
            break;
        default:
            toast(message, options);
            break;
    }
};

/** Billing / subscription / credit toasts — rendered in AdminLayout (above modals). */
export const showAdminToast = (type, message, customOptions = {}) =>
    showToast(type, message, {
        containerId: ADMIN_TOAST_CONTAINER_ID,
        ...customOptions,
    });